module.exports = __webpack_public_path__ + "hr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/hr.svg
// module id = 852
// module chunks = 0